import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Action } from '../../action.model';
import { TableRow } from '../../model';
import { ColumnComponent } from '../column.component';
import { TableSortKey } from '../shared';

const regular = {};
const sortable = { 'icon-sort': true };
const ascending = { 'icon-sort': true, 'icon-sort-ascending': true };
const descending = { 'icon-sort': true, 'icon-sort-descending': true };

const actionClasses = ['mod-actions-1', 'mod-actions-2', 'mod-actions-3', 'mod-actions-4'];

@Component({
  selector: 'thead[cp-head]',
  templateUrl: './table-header.component.html',
  styleUrls: [
    './table-header.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeaderComponent {
  @Input()
  columns: ColumnComponent[];

  @Input()
  inlineActions: Array<Action<TableRow>>;

  @Input()
  hideActions?: boolean;

  @Input()
  sortedBy: TableSortKey;

  @Input()
  isAllSelected: boolean;

  @Input()
  panel?: boolean;

  @Input()
  hideSelection?: boolean;

  @Output()
  toggleAll = new EventEmitter();

  @Output()
  sort = new EventEmitter<ColumnComponent>();

  get actionClass() {
    return actionClasses[this.inlineActions.length - 1];
  }

  getColumnClass(column: ColumnComponent) {
    return column.headerClass
      ? `${column.columnClass} ${column.headerClass}`
      : column.columnClass;
  }

  getSortIcon(column: ColumnComponent) {
    const isCurrentSortKey = this.sortedBy.key === column;

    if (isCurrentSortKey) {
      return this.sortedBy.descending ? descending : ascending;
    } else {
      return column.sortable ? sortable : regular;
    }
  }
}


